import React, { useState, useEffect } from 'react';
import Axios from "axios";
import { DeActivateLeads, GetAllLeads, UpdateLeadOutreachStatus } from '../apiconstants/constants';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import { Button, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useCountry } from '../contexts/countrycodecontext.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 20) + "...";
}

const ListOfLeads = () => {
  const [offset, setOffset] = useState(0);
  let query = useQuery();
  const roleid = localStorage.getItem("roleID");
  const [data, setData] = useState([]);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
  const [showModal,setShowModal] = useState(false)
  const [LeadID, setLeadID] = useState(null);
  const [status, setStatus] = useState(null);
  const [leadStatusFilter, setLeadStatusFilter] = useState("active"); // default to Active
  const [currentStageFilter, setCurrentStageFilter] = useState("all");
const [showStatusModal, setShowStatusModal] = useState(false);
const [statusLeadId, setStatusLeadId] = useState(null);
const [newStatus, setNewStatus] = useState("Engaged"); // default
const [lastMailDateFilter, setLastMailDateFilter] = useState("");
const [nextMailDateFilter, setNextMailDateFilter] = useState("");
const [showEmailChoiceModal, setShowEmailChoiceModal] = useState(false);
const [emailChoice, setEmailChoice] = useState(""); // "ai" | "custom"
const token = localStorage.getItem("jwtToken");
  const statusColors = {
  'Initial': '#3855adff',       // Light Blue
  'FollowUp-1': '#0000ff',    // Blue
  'Engaged': '#006400',       // Dark Green
  'FollowUp-2': '#90ee90',    // Light Green
  'FollowUp-3': '#ff0000',    // Red
  'Not Replied':'#ea0909ff'
};

  const navigate = useNavigate();
  const {selectedCountry} = useCountry();
  const handleViewToggle = (type) => {
    setViewType(type);
    setShowIcon(type)
  };
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };

  let Guid="";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
  const email = localStorage.getItem("email")
  const roleID = localStorage.getItem("roleID")
  
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }
  
  const handleDeactivateVendor = (leadGuid,isActive) => {
    setLeadID(leadGuid);
    setStatus(isActive)
    setShowModal(true)
  };
  const handleCancel = () => {
    setShowModal(false);
  };
  const GetCandidateList = () => {
    setIsLoading(true);
    const GetapiUrl = `${GetAllLeads.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
    Axios.get(GetapiUrl,{ headers: { Authorization: `Bearer ${token}` } })
      .then((result) => {
        setIsLoading(false);
       
        if (roleid==4){ setCandidateData(result.data.filter((x)=>x.createdBy!="info@knackhook.com"));}
        else {setCandidateData(result.data)}
      }).catch((error) => {
        console.log("Error" + error);
      });
  };
  const handleUserStatus = () => {
        
    const APIURL = `${DeActivateLeads.APIURL}?ID=${LeadID}&type=${!(status)}`;

    setIsLoading(true); // Set loading state before API call

   Axios.put(APIURL, null, {
    headers: { Authorization: `Bearer ${token}` }
  })
        .then((result) => {
  
            setIsLoading(false); // Set loading state to false after API call
            setCandidateData(prevLeads =>
              prevLeads.map(lead =>
                lead.id == LeadID ? { ...lead, isActive: !status } : lead
              )
          );
            // Show success message based on API response
            if (result.data.message === "Lead Activated successfully.") {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Activated Successfully',
                    showConfirmButton: false,
                    timer: 5000,
                });
                GetCandidateList();
            } else if (result.data.message === "Lead Deactivated successfully.") {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Deactivated Successfully',
                    showConfirmButton: false,
                    timer: 5000,
                });
                GetCandidateList();
            }
          
            setShowModal(false);

        })
        .catch((error) => {
            console.error("Error: ", error); // Log error for debugging
            setIsLoading(false); // Set loading state to false in case of error


        });
};

  useEffect(() => {
    GetCandidateList();
  }, [selectedCountry]);

 useEffect(() => {
  const normalizeDate = (dateStr) => {
  if (!dateStr || dateStr === "null") return "";
  try {
    // Always cut to YYYY-MM-DD without timezone shifts
    return dateStr.split("T")[0];
  } catch {
    return "";
  }
};

const filteredData = candidateData.filter(candidate => {
  const matchesSearch =
    candidate?.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    candidate?.companyName?.toLowerCase().includes(searchTerm.toLowerCase());

  const actualStatus = String(candidate.isActive).toLowerCase();
  const matchesStatus =
    leadStatusFilter === "all" ||
    (leadStatusFilter === "active" && actualStatus === "true") ||
    (leadStatusFilter === "deactive" && actualStatus === "false");

  const matchesStage =
    currentStageFilter === "all" ||
    candidate.currentStage === currentStageFilter;

  // ✅ Exact match with normalized date
  const candidateLastMail = normalizeDate(candidate.lastSentDate);
  const matchesLastMail =
    !lastMailDateFilter || candidateLastMail === lastMailDateFilter;

  const candidateNextMail = normalizeDate(candidate.nextMailDate);
  const matchesNextMail =
    !nextMailDateFilter || candidateNextMail === nextMailDateFilter;

  return (
    matchesSearch &&
    matchesStatus &&
    matchesStage &&
    matchesLastMail &&
    matchesNextMail
  );
});


  setFilteredItems(filteredData);

  const slice = filteredData.slice(offset, offset + perPage);
  const items = viewType === 'grid'
    ? slice.map((data) => {
        const isSelected = selectedItems.some(item => item.id === data.id);
        return (
        <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.guid}>
          <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 620, height: 580, borderRadius: 20 }}>
            <div className='card-header' style={{ background: "none", minHeight: 140 }}>
              <div className='row'>
                <div className='col-8'>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                    <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.fullName}</b></p>
                  </OverlayTrigger>
               {data.companyName !=''&&   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Company Name</Tooltip>)}>
                    <h5 style={{ fontSize: 18 }}>{data.companyName}</h5>
                  </OverlayTrigger>}
                </div>
                <div className='col-4'>
                 
                </div>
              </div>
            </div>
            <div className="card-body">
            {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Phone Number</Tooltip>)}>

              <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-mobile" aria-hidden="true"></i> {data.phoneNumber} </p>
           </OverlayTrigger> */}
     <OverlayTrigger 
      placement="bottom" 
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>Phone Number</Tooltip>
      )}
    >
      <div className='whatsapp' style={{ display: 'flex', alignItems: 'center' }}>
        {/* Phone Number Link */}
        <a 
          href={`tel:${data.phoneNumber}`} 
          style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', marginRight: 10 }}
        >
          <i 
            style={{ fontSize: 14, color: "#00a7ac", marginRight: 5 }} 
            className="fa fa-mobile" 
            aria-hidden="true"
          ></i>
          <p style={{ fontSize: 14, textAlign: 'justify', margin: 0, color: 'inherit' }}>
            {data.phoneNumber}
          </p>
        </a>

        {/* WhatsApp Link */}
        <a 
          href={`https://wa.me/${data.phoneNumber}`} 
          target="_blank" 
          rel="noopener noreferrer" 
          style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
        >
          <i 
            style={{ fontSize: 20, color: "#00a7ac", marginLeft: 8 }} 
            className="fab fa-whatsapp-square" 
            aria-hidden="true"
          ></i>
         
        </a>
      </div>
    </OverlayTrigger>
{
  data.email !='' &&  data.email != null && data.email!='null' && (
    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
      <a href={`mailto:${data.email}`} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', marginRight: 10, marginBottom:10}}>
        <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 5 }} className="fa fa-envelope" aria-hidden="true"></i>
        <p style={{ fontSize: 14, textAlign: 'justify', margin: 0, color: 'inherit'}}>{data.email}</p>
      </a>
    </OverlayTrigger>
  )
}

             {data.domain !=''&&   data.domain != null && data.domain!='null' && 
             <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.domain}</Tooltip>)}>
             <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user-tie" aria-hidden="true"></i> {substring_str(data.domain)} </p>
             </OverlayTrigger>}
             {data.dateOfBirth !=''&&   data.dateOfBirth != null && data.dateOfBirth !='null' &&      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>DOB</Tooltip>)}>
             <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-calendar" aria-hidden="true"></i> {data.dateOfBirth}</p>
              </OverlayTrigger> }

              {data.websiteURL !='' &&  data.websiteURL != null && data.websiteURL!='null' &&    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Website URL</Tooltip>)}>
              <a 
            href={data.websiteURL?.startsWith('http') ? data.websiteURL : `https://${data.websiteURL}`} 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <p className="text-para"  style={{ fontSize: 14}}>
           
                <i className="fa fa-graduation-cap icons mr-2"></i>
                {data.websiteURL}
            </p>
        </a>         
            </OverlayTrigger>}
            {data.linkdinUrl != ''  &&  data.linkdinUrl != null && data.linkdinUrl!='null' &&
  <OverlayTrigger 
    placement="bottom" 
    overlay={(props) => (<Tooltip id="tooltip" {...props}>Linkedin URL</Tooltip>)}
  >
    <a 
      href={data.linkdinUrl?.startsWith('http') ? data.linkdinUrl : `https://${data.linkdinUrl}`} 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <div className="linkedin-container" style={{ display: 'flex', alignItems: 'center', maxWidth: '100%', overflow: 'hidden' }}>
        <i className="fab fa-linkedin icons mr-1" style={{ marginRight:14 }}></i>
        <p className="text-para" style={{ fontSize: 14, margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', marginLeft:8,textOverflow: 'ellipsis' }}>
          {data.linkdinUrl}
        </p>
      </div>
    </a>
  </OverlayTrigger>
}
<div className="d-flex align-items-center mt-2">
  {data.currentStage && data.currentStage !== 'null' && data.currentStage.trim() !== '' && (
    <>
      {(() => {
        // Extract clean stage name without Outreach-
        const stage = data?.currentStage;

        const color = statusColors[stage] || '#808080'; // default grey

        return (
          <>
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Status</Tooltip>}>
              <span
                style={{
                  color: color,
                  padding: '3px 8px',
                  borderRadius: '5px',
                  fontSize: '13px',
                   display: 'flex',            // ✅ matches LinkedIn cell layout
              alignItems: 'center',       // ✅ vertical center
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px', // space between icon & text
                  minWidth: '90px',
                  textAlign: 'center'
                }}
              >
                <i className="fas fa-hourglass-half mr-2" style={{color:"#00a7ac",marginLeft:-9}}></i>
                {stage}
              </span>
            </OverlayTrigger>

            <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit Status</Tooltip>}>
              <FontAwesomeIcon
  icon="fas fa-pencil-alt"
  onClick={() => {
    setStatusLeadId(data.id);
    setNewStatus("Engaged"); // default selected
    setShowStatusModal(true);
  }}
      style={{
                  marginLeft: 8,
                  color: "#00a7ac",
                  fontSize: 14,
                  cursor: "pointer"
                }}
/>

            </OverlayTrigger>
          </>
        );
      })()}
    </>
  )}
</div>


                                               {data.lastSentDate != ''  &&  data.lastSentDate != null && data.lastSentDate!='null' &&
 <OverlayTrigger placement="bottom" overlay={<Tooltip>Last Mail Date</Tooltip>}>
                                    <p className="text-para mt-2" style={{ fontSize: 14 }} >
                                      <i className="fas fa-calendar" style={{ color: "#00a7ac", marginRight: 10 }}  ></i>
                                      {data.lastSentDate?.split('T')[0]}
                                    </p>
                                  </OverlayTrigger>
                                   }
                                   
                                               {data.nextMailDate != ''  &&  data.nextMailDate != null && data.nextMailDate!='null' &&
 <OverlayTrigger placement="bottom" overlay={<Tooltip>Next Mail Date</Tooltip>}>
                                    <p className="text-para mt-2" style={{ fontSize: 14 }} >
                                      <i className="fas fa-calendar" style={{ color: "#00a7ac", marginRight: 10 }}  ></i>
                                      {data.nextMailDate?.split('T')[0]}
                                    </p>
                                  </OverlayTrigger>
                                   }
              </div>
           
                 <div className='card-footer d-flex justify-content-between'>
                <Link style={{}} to={"/Employer/EditLead?LeadID=" + data.id}>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Edit</Tooltip>)}>
                    <button style={{ background: "none", border: "none" }}><i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                  </OverlayTrigger>

                </Link>
                <Link style={{}} to={"/Employer/ViewLead?data=" + data.id}>
                                                     <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>View</Tooltip>)}>
                                                         <button style={{ background: "none", border: "none" }}>
                                                             <i className="fa fa-eye mt-1" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                                                         </button>
                                                     </OverlayTrigger>
                                                 </Link>
 <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> {data.isActive ? 'Deactivate Lead' : 'Activate Lead'}</Tooltip>)}>
                             <button onClick={() => handleDeactivateVendor(data.id, data.isActive) }style={{ background: "none", border: "none" }}>
                            <i className={`fa fa-${data.isActive ? 'toggle-on' : 'toggle-off'}`} aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                            </button>
               
                           </OverlayTrigger>
                           {data.email && data.currentStage!='Engaged' && data.currentStage!='Not Replied' && data.currentStage!='FollowUp-3' &&(
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select</Tooltip>)}>
    <input
      type="checkbox"
      checked={isSelected}
      onChange={() => handleCheckboxChange(data)}
    />
  </OverlayTrigger>
)}
              </div>
            
          </div>
        </div>
      )
    }):
   <div className="col-12" style={{ width: "100%" }}>
  <table
    className="table"
    style={{
      fontSize: "12px",
      tableLayout: "fixed",   // ✅ ensures fixed column sizing
      width: "100%",          // ✅ keeps table inside screen
      wordWrap: "break-word",
    }}
  >
    <thead>
      <tr>
        <th style={{ width: "12%" }}>Full Name</th>
        <th style={{ width: "12%" }}>Company Name</th>
        <th style={{ width: "14%" }}>Phone Number</th>
        <th style={{ width: "10%" }}>Email</th>   {/* ✅ narrow */}
        <th style={{ width: "12%" }}>Description</th>
        <th style={{ width: "20%" }}>LinkedIn URL</th> {/* ✅ wider */}
        <th style={{ width: "8%" }}>Status</th>
        <th style={{ width: "5%" }}>Last Mail Date</th>
        <th style={{ width: "5%" }}>Next Mail Date</th>
        <th style={{ width: "10%" }}>Actions</th>
      </tr>
    </thead>

    <tbody>
      {slice?.map((data, index) => {
        const isSelected = selectedItems.some(item => item.id === data.id);
          return (
            <tr key={index}>
              <td>{data.fullName}</td>
            <td>{data.companyName}</td>
              <td>
                <div className="whatsapp" style={{ display: 'flex', alignItems: 'center' }}>
                  {/* Phone Number Link */}
                  <a
                    href={`tel:${data.phoneNumber}`}
                    style={{
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      marginRight: 10,
                    }}
                  >
                    <i
                      style={{ fontSize: 14, color: '#00a7ac', marginRight: 5 }}
                      className="fa fa-mobile"
                      aria-hidden="true"
                    ></i>
                    <p style={{ fontSize: 12, margin: 0, color: 'inherit' }}>
                      {data.phoneNumber}
                    </p>
                  </a>

                  {/* WhatsApp Link */}
                  <a
                    href={`https://wa.me/${data.phoneNumber}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <i
                      style={{ fontSize: 20, color: '#00a7ac', marginLeft: 8 }}
                      className="fab fa-whatsapp-square"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </td>
         <td style={{ wordBreak: "break-all" }}>{data.email}</td>         
           <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.domain}</Tooltip>)}>
              <td>{substring_str(data.domain)}</td>
              </OverlayTrigger>
             
              <td style={{ wordBreak: "break-word" }}>
              <a
                href={data.linkdinUrl?.startsWith("http") ? data.linkdinUrl : `https://${data.linkdinUrl}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {data.linkdinUrl}
              </a>
            </td>
   <td>
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {(() => {
      const stage = data?.currentStage;
      const color = statusColors[stage] || 'inherit';
      return (
        <>
          <span
            style={{
              // color: color,
              color: color,
              // padding: '3px 8px',
              borderRadius: '5px',
              fontSize: '13px',
              fontWeight: 'bold',
              minWidth: '65px',
              textAlign: 'left',
            }}
          >
            {stage}
          </span>
          {stage && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit Status</Tooltip>}>
                   <FontAwesomeIcon
  icon="fas fa-pencil-alt"
  onClick={() => {
    setStatusLeadId(data.id);
    setNewStatus("Engaged"); // default selected
    setShowStatusModal(true);
  }}
      style={{
                  marginLeft: 3,
                  color: "#00a7ac",
                  fontSize: 14,
                  cursor: "pointer"
                }}
/>
            </OverlayTrigger>
          )}
        </>
      );
    })()}
  </div>
</td>


              <td>{data.lastSentDate?.split('T')[0]}</td>
              <td>{data.nextMailDate?.split('T')[0]}</td>
              
              <td style={{ padding: "4px" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              justifyContent: "center",
            }}
          >
 
    <Link to={`/Employer/EditLead?LeadID=${data.id}`}>
      <OverlayTrigger
        placement="bottom"
        overlay={(props) => <Tooltip id="tooltip" {...props}> Edit</Tooltip>}
      >
        <button style={{ background: 'none', border: 'none' }}>
          <i
            className="fa fa-edit"
            aria-hidden="true"
            style={{ fontSize: 16, color: '#00a7ac' }}  // Reduced size to 16px
          ></i>
        </button>
      </OverlayTrigger>
    </Link>

    <Link to={"/Employer/ViewLead?data=" + data.id}>
      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>View</Tooltip>)}>
        <button style={{ background: "none", border: "none" }}>
          <i
            className="fa fa-eye mt-1"
            aria-hidden="true"
            style={{ fontSize: 16,  color: "#00a7ac" }}  // Reduced size to 16px
          ></i>
        </button>
      </OverlayTrigger>
    </Link>

    <OverlayTrigger
      placement="bottom"
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>
          {data.isActive ? 'Deactivate Lead' : 'Activate Lead'}
        </Tooltip>
      )}
    >
      <button
        onClick={() => handleDeactivateVendor(data.id, data.isActive)}
        style={{ background: 'none', border: 'none' }}
      >
        <i
          className={`fa fa-${data.isActive ? 'toggle-on' : 'toggle-off'}`}
          aria-hidden="true"
          style={{ fontSize: 16, color: '#00a7ac' }}  // Reduced size to 16px
        ></i>
      </button>
    </OverlayTrigger>

    {data.email && data.currentStage!='Engaged' && data.currentStage!='Not Replied' && data.currentStage!='FollowUp-3' &&(
      <OverlayTrigger
        placement="bottom"
        overlay={(props) => <Tooltip id="tooltip" {...props}>Select</Tooltip>}
      >
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => handleCheckboxChange(data)}
        />
      </OverlayTrigger>
    )}
  </div>
</td>

            </tr>
          );
        })}
      </tbody>
    </table>
  </div>


    setData(items);
  setPageCount(Math.ceil(filteredData.length / perPage));
}, [offset, searchTerm, candidateData, perPage, selectedItems, viewType, leadStatusFilter, currentStageFilter,lastMailDateFilter,nextMailDateFilter]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setOffset(0);
  };

  const handleCheckboxChange = (item) => {
    const selectedIndex = selectedItems.findIndex(selectedItem => selectedItem.id === item.id);

    if (selectedIndex === -1) {
      setSelectedItems([...selectedItems, item]);
    } else {
      const updatedItems = [...selectedItems];
      updatedItems.splice(selectedIndex, 1);
      setSelectedItems(updatedItems);
    }
  };

const handleSelectAll = () => {
  if (selectAll) {
    setSelectedItems([]);
  } else {
    const filteredItemsWithEmail = filteredItems?.filter(item => item.email && item.currentStage!='Engaged'&& item.currentStage!='Not Replied' && item.currentStage!='FollowUp-3' );
    setSelectedItems(filteredItemsWithEmail);
  }
  setSelectAll(!selectAll);
};

  
const handleForwardClick = () => { 
  if (selectedItems.length === 0) return;

  localStorage.setItem("selectedLeads", JSON.stringify(selectedItems));

  if (selectedItems.length > 1) {
    // Multiple leads → no AI email, go directly
    localStorage.setItem("aimail", false);
    navigate("SelectedLeads");
  } else if (selectedItems.length === 1) {
    // Single lead → show full modal (AI, Custom, Generic)
    setEmailChoice("");
    setShowEmailChoiceModal(true);
  }
};
const handleEmailChoiceSubmit = () => {
  if (emailChoice === "ai") {
    localStorage.setItem("aimail", true);
    navigate("SelectedLeads");
  } else if (emailChoice === "generic") {
    localStorage.setItem("aimail", false);
    navigate("SelectedLeads");
  } else if (emailChoice === "custom") {
    localStorage.setItem("aimail", false);
    navigate("SelectedLeadsCustomMail");
  }
  setShowEmailChoiceModal(false);
};


const handleStatusSubmit = () => {
  setIsLoading(true);

  const payload = {
    leadId: statusLeadId,
    status: newStatus,   // sending selected status
    userGuid: Guid
  };

  Axios.post(`${UpdateLeadOutreachStatus.APIURL}`, payload,
    { headers: { Authorization: `Bearer ${token}` } }
  )
    .then((result) => {
      setIsLoading(false);
      setShowStatusModal(false);

      Swal.fire({
        position: "center",
        icon: "success",
        title: "Status updated successfully",
        showConfirmButton: false,
        timer: 3000
      });

      GetCandidateList(); // refresh table
    })
    .catch((error) => {
      setIsLoading(false);
      console.error("Error updating status:", error);
      Swal.fire("Error updating status!");
    });
};
   
  const handleResetFilters = () => {
  setSearchTerm("");
  setLeadStatusFilter("all");
  setCurrentStageFilter("all");
  setLastMailDateFilter("");
  setNextMailDateFilter("");
  setOffset(0);
};


  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
        <div className="responsive-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 className="" style={{ color: "#00a7ac" }}>List of Leads</h2>
         </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              id="searchvendor"
              type="text"
              placeholder="Search by Full Name or Company Name"
              className="form-control"
              value={searchTerm}
              onChange={handleSearch}
              style={{ marginRight: '10px',width:1100 }}
            />
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Last Mail Date</Tooltip>)}>

            <input
  type="date"
  className="form-control"
  value={lastMailDateFilter}
  onChange={(e) => setLastMailDateFilter(e.target.value)}
  style={{ width: 180, height: 50, marginRight: 10 }}
  placeholder="Filter Last Mail Date"
/>
</OverlayTrigger>
    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Next Mail Date</Tooltip>)}>

<input
  type="date"
  className="form-control"
  value={nextMailDateFilter}
  onChange={(e) => setNextMailDateFilter(e.target.value)}
  style={{ width: 180, height: 50, marginRight: 10 }}
  placeholder="Filter Next Mail Date"
/>
</OverlayTrigger>
      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Apply Status Filter</Tooltip>)}>
        
<select
  className="form-control"
  value={currentStageFilter}
  onChange={(e) => setCurrentStageFilter(e.target.value)}
  style={{ width: 150, height: 50, marginRight: 10 }}
>
  <option value="all">All Status</option>
  <option value="Initial">Initial</option>
    <option value="Engaged">Engaged</option>
  <option value="FollowUp-1">FollowUp 1</option>
  <option value="FollowUp-2">FollowUp 2</option>
  <option value="FollowUp-3">FollowUp 3</option>
  <option value="Not Replied">Not Replied</option>
</select>
</OverlayTrigger>
  <select
             id="searchvendor"
              className="form-control"
              value={leadStatusFilter}
              onChange={(e) => setLeadStatusFilter(e.target.value)}
              style={{ width: 150, height:50, marginRight: 10 }}
            >
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="deactive">Deactive</option>
            </select>
<button
  className="btn btn-secondary"
  style={{ marginRight: "10px", height: "50px" }}
  onClick={handleResetFilters}
>
   <i className="fas fa-sync mr-2"></i>Reset
</button>

        
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Add Lead</Tooltip>)}>
                <Link to="/Employer/AddLead">
                  <button className="btn btn-primary mr-3" btn-ype="button"><i className="fa fa-plus"></i></button>
                </Link>
              </OverlayTrigger>
               {showIcon === 'grid' && (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                    <button
                      className="btn btn-primary mr-3"
                      onClick={() => handleViewToggle('list')}
                      style={{ backgroundColor: "#00a7ac", height: "38px", width: "38px", display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                      <i className="fa fa-th-list" style={{ color: '#fff', fontSize: "16px" }}></i>
                    </button>
                  </OverlayTrigger>
                )}
              
                {showIcon === 'list' && (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                    <button
                      className="btn btn-primary mr-3"
                      onClick={() => handleViewToggle('grid')}
                      style={{ backgroundColor: "#00a7ac", height: "38px", width: "38px", display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                      <i className="fa fa-th" style={{ color: '#fff', fontSize: "16px" }}></i>
                    </button>
                  </OverlayTrigger>
                )}
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Import Leads</Tooltip>)}>
              <Link to="/Employer/AddBulkLeads">
              <button className="btn btn-primary mr-3" type="button" >
              <i class="fas fa-upload"></i>
                </button>
                </Link></OverlayTrigger>
        </div>
      
        {selectedItems.length > 0 && selectedItems.some(item => item.email) && (
  <div style={{ textAlign: 'right', marginTop: '10px' }}>
    <button className="btn btn-primary" onClick={handleForwardClick}>
      <i className="fa fa-arrow-right"></i> Send Email
    </button>
  </div>
)}

        <hr />
 <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
  <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
    <input
      type="checkbox"
      checked={selectAll}
      onChange={handleSelectAll}
      style={{ marginRight: "5px" }}
    />
    Select All
  </label>
</div>
<hr />

        {isLoading ? (
          <center><LoadingSpinner /></center>
        ) : (
          <>
            {candidateData.length > 0  && filteredItems.length > 0 ? (
              <div className="row mt-5 pb-3">
                {data}
              </div>
            ) : (
              <div className="pb-5 text-center">
                <img title='No Data' className='no-data-img' alt="no-data-img" src={nodataimg} style={{ height: 370 }} />
              </div>
            )}
          </>
        )}
        {
          candidateData.length>0  && filteredItems.length  > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }
                <Modal show={showModal} style={{textAlign:"center"}} onHide={handleCancel}>
                <Modal.Header closeButton>
                  <Modal.Title style={{color:"#00a7ac"}}>Confirm Deactivation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to Activate/Deactivate this Lead?</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCancel}>No</Button>
                  <Button variant="primary" onClick={handleUserStatus}>Yes</Button>
                </Modal.Footer>
              </Modal>
              <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title style={{ color: "#00a7ac" }}>Update Mail Status</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <label>
        <input
          type="radio"
          value="Engaged"
          checked={newStatus === "Engaged"}
          onChange={(e) => setNewStatus(e.target.value)}
          style={{ marginRight: "5px" }}
        />
        Engaged
      </label>
      <label>
        <input
          type="radio"
          value="Not Replied"
          checked={newStatus === "Not Replied"}
          onChange={(e) => setNewStatus(e.target.value)}
          style={{ marginRight: "5px" }}
        />
        Not Replied
      </label>
    </div>
  </Modal.Body>
  <Modal.Footer>
  
    <Button
      variant="primary"
      onClick={() => handleStatusSubmit()}
    >
      Update
    </Button>
      <Button variant="secondary" onClick={() => setShowStatusModal(false)}>
      Cancel
    </Button>
  </Modal.Footer>
</Modal>
<Modal
  show={showEmailChoiceModal}
  onHide={() => setShowEmailChoiceModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title style={{ color: "#00a7ac" }}>Choose Email Type</Modal.Title>
  </Modal.Header>
<Modal.Body>
  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
    {selectedItems.length === 1 && (
      <label>
        <input
          type="radio"
          value="ai"
          checked={emailChoice === "ai"}
          onChange={(e) => setEmailChoice(e.target.value)}
          style={{ marginRight: "5px" }}
        />
        AI Generated Mail
      </label>
    )}
    <label>
      <input
        type="radio"
        value="custom"
        checked={emailChoice === "custom"}
        onChange={(e) => setEmailChoice(e.target.value)}
        style={{ marginRight: "5px" }}
      />
      Custom Email
    </label>
    <label>
      <input
        type="radio"
        value="generic"
        checked={emailChoice === "generic"}
        onChange={(e) => setEmailChoice(e.target.value)}
        style={{ marginRight: "5px" }}
      />
      Generic Email
    </label>
  </div>
</Modal.Body>

  <Modal.Footer>
    <Button
      variant="primary"
      onClick={handleEmailChoiceSubmit}
      disabled={!emailChoice} // disable until user selects one
    >
      Continue
    </Button>
    <Button
      variant="secondary"
      onClick={() => setShowEmailChoiceModal(false)}
    >
      Cancel
    </Button>
  </Modal.Footer>
</Modal>

      </div>
    </ConsultantLayout>
  );
}

export default ListOfLeads;
